import { withStyles } from '@material-ui/core';

import NewButton from './NewButton';
import { styles } from './NewButton.styles';

const NewButtonContainer = withStyles(styles)(NewButton);

export default NewButtonContainer;
